import { css } from 'lit';
export const AllInMembersBase = (superclass) => class extends superclass {
    _getEvidenceRequiredProvisions(withEvidence = false) {
        let provisionsRequireEvidence = [];
        let rawProvisions = [];
        this.provisions.forEach((provision) => {
            rawProvisions = [...rawProvisions, ...provision.provisions];
        });
        console.log(this.membership);
        this.membership?.provisions?.forEach((prov) => {
            let standard = rawProvisions.find((p) => p.id == prov.standard.id);
            if (withEvidence) {
                if (standard?.evidenceRequired && standard.evidenceRequired == '1') {
                    prov.details = standard;
                    provisionsRequireEvidence.push(prov);
                }
            }
            else {
                if (standard?.evidenceRequired & prov.evidence.length == 0) {
                    prov.details = standard;
                    provisionsRequireEvidence.push(prov);
                }
                else {
                    let latestEvidence = prov.evidence.sort((a, b) => new Date(b.validUntil) - new Date(a.validUntil))[0];
                    if (standard?.evidenceRequired && latestEvidence?.status == 'RequestInfo') {
                        prov.details = standard;
                        provisionsRequireEvidence.push(prov);
                    }
                }
            }
        });
        return provisionsRequireEvidence;
    }
    static styles = [css `
    .bg_grey,.bg.bg_grey {
        background-color: var(--color-grey, #e8e8e8);
    }
    .profile-card dl{
            display:grid;
            row-gap:0.5rem;
            margin:0;
            grid-template-columns: 1fr;
            dd{
                font-weight:600;
                margin:0;
                span{
                    background-color: #fff;
                    display:inline-block;
                    padding:0.15rem 0.25rem;
                    margin-left:0.4rem;
                    font-weight:400;
                }
               
            }
        }
        .message:not(.form_response){
            background-color: var(--allin-button-bg-color,#fff);
            border: 1px solid var(--allin-button-color,#472961);
            padding:1rem;
            margin-bottom:1rem;
        }
        @media screen and (min-width:700px){
            .profile-card dl{
                grid-template-columns: max-content 1fr;
                column-gap:2rem;
                dt{
                    grid-column:1/2;
                    margin-bottom:0.5rem;
                }
                dd{
                    grid-column:2/3;
                    &:has(span){
                        display:grid;
                        grid-template-columns:1fr max-content;
                        align-items:center;
                    }
                }
            }
        }

    `];
};
